import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from '../services/authguard.service';
import { LoginComponent } from '../pages/login/login.component';
import { UsuariosComponent } from '../pages/usuarios/usuarios.component';
import { HomeComponent } from '../pages/home/home.component';
import { AlumnosComponent } from '../pages/alumnos/alumnos.component';
import { PlanificacionesComponent } from '../pages/planificaciones/planificaciones.component';
import { EvaluacionesComponent } from 'src/pages/evaluaciones/evaluaciones.component';
import { AuthGuard } from './guards/auth.guard';
import { InformeAlumnoComponent } from 'src/pages/informe/informeAlumno/informe-alumno.component';
import { InformeCursoComponent } from 'src/pages/informe/informeCurso/informe-curso.component';


const appRoutes: Routes = [
    { path: 'login', component: LoginComponent },
    { path: 'usuarios', component: UsuariosComponent, canActivate: [AuthGuard] },
    { path: 'home', component: HomeComponent, canActivate: [AuthGuardService] },
    { path: 'alumnos', component: AlumnosComponent, canActivate: [AuthGuardService] },
    { path: 'planificaciones', component: PlanificacionesComponent, canActivate: [AuthGuardService] },
    { path: 'evaluaciones', component: EvaluacionesComponent, canActivate: [AuthGuardService] },
    { path: 'informeAlumno', component: InformeAlumnoComponent, canActivate: [AuthGuardService] },
    { path: 'informeCurso', component: InformeCursoComponent, canActivate: [AuthGuardService] },
    { path: '**', pathMatch: 'full', redirectTo: 'login' }
];


export const APP_ROUTING = RouterModule.forRoot(appRoutes, {useHash: false });
